// extracted by mini-css-extract-plugin
export default {"input":"_1oAXNYb1WL7U0r7eWLNhih"};